// src/components/rbac/AdminRBAC.jsx
import React, { useState } from "react";
import RoleManager from "./RoleManager";
import PermissionManager from "./PermissionManager";
import RolePermissionManager from "./RolePermissionManager";
import AdminRoleManager from "./AdminRoleManager";
import Sidebar from "../Sidebar";

const tabs = [
  { key: "roles", label: "Roles" },
  { key: "perms", label: "Permissions" },
  { key: "rolePerms", label: "Role → Permissions" },
  { key: "adminRoles", label: "Admin → Roles" },
];

export default function AdminRBAC() {
  const [active, setActive] = useState("roles");

  return (
    // ensure page reserves space for fixed sidebar on large screens
    <div className="min-h-screen bg-[#0c0b0b]">
      <Sidebar />

      {/* On large screens add padding-left equal to sidebar width (w-72).
          On smaller screens no left padding so the mobile toggle can overlay. */}
      <div className="lg:pl-72">
        <div className="pt-8 pl-6 pr-6">
          <div className="flex items-center justify-between">
            <p className="font-be-jost-pro text-2xl font-bold text-[#FBB033]">
              RBAC Management
            </p>

            <div className="flex items-center gap-3">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-md text-[#FBB033] border border-[#FBB033] font-be-jost-pro font-medium text-sm"
              >
                Refresh
              </button>
              <button
                onClick={() => setActive("roles")}
                className="px-4 py-2 rounded-md bg-[#FBB034] text-black font-be-jost-pro font-medium text-sm"
              >
                Go to Roles
              </button>
            </div>
          </div>

          {/* Tabs */}
          <div className="mt-4">
            <div className="flex gap-2 mb-4">
              {tabs.map((t) => (
                <button
                  key={t.key}
                  onClick={() => setActive(t.key)}
                  className={`px-4 py-2 rounded ${
                    active === t.key
                      ? "bg-[#FBB034] text-black"
                      : "bg-[#0c0b0b] text-white border border-[#E0E0E0]"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>

            {/* Content card */}
            <div className="bg-[#1a1a1a] p-4 rounded">
              {active === "roles" && <RoleManager />}
              {active === "perms" && <PermissionManager />}
              {active === "rolePerms" && <RolePermissionManager />}
              {active === "adminRoles" && <AdminRoleManager />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
